import {
  SortOption,
  SortState,
  Direction,
  SortOptionSelectItem,
  sort,
} from '../../../utils/sort';
import { OrgsSortBy, SortableOrgs } from './types';

export const orgsSortingReducer = (
  state: SortState<SortableOrgs>,
  action: SortOption<OrgsSortBy>
): SortState<SortableOrgs> => {
  const getDirectionByPrevious = (direction?: Direction) => {
    return direction === Direction.ASC ? Direction.DESC : Direction.ASC;
  };

  switch (action.sortBy) {
    case OrgsSortBy.NAME:
      return {
        name: action.direction || getDirectionByPrevious(state.name),
      };
    case OrgsSortBy.DEVICES:
      return {
        deviceCount:
          action.direction || getDirectionByPrevious(state.deviceCount),
      };
    case OrgsSortBy.MEASUREMENTS:
      return {
        measurementCount:
          action.direction || getDirectionByPrevious(state.measurementCount),
      };
    default:
      return state;
  }
};

export const mobileSortOptions: SortOptionSelectItem<OrgsSortBy>[] = [
  {
    value: { sortBy: OrgsSortBy.NAME, direction: Direction.ASC },
    label: 'Name (ascending)',
    id: 'name-asc',
  },
  {
    value: { sortBy: OrgsSortBy.NAME, direction: Direction.DESC },
    label: 'Name (descending)',
    id: 'name-desc',
  },
  {
    value: { sortBy: OrgsSortBy.DEVICES, direction: Direction.ASC },
    label: 'Device count (ascending)',
    id: 'devices-asc',
  },
  {
    value: { sortBy: OrgsSortBy.DEVICES, direction: Direction.DESC },
    label: 'Device count (descending)',
    id: 'devices-desc',
  },
  {
    value: {
      sortBy: OrgsSortBy.MEASUREMENTS,
      direction: Direction.ASC,
    },
    label: 'Measurements (ascending)',
    id: 'measurements-asc',
  },
  {
    value: {
      sortBy: OrgsSortBy.MEASUREMENTS,
      direction: Direction.DESC,
    },
    label: 'Measurements (descending)',
    id: 'measurements-desc',
  },
];

export const sortOrgs = (
  orgs: SortableOrgs[],
  sortState: SortState<SortableOrgs>
) => {
  return sort(orgs, sortState, {
    name: (o) => o.name,
    deviceCount: (o) => o.deviceCount,
    measurementCount: (o) => o.measurementCount,
  });
};
